import { ResponsiveImage } from '../ResponsiveImage';

interface ImageProps {
  url?: string;
  urlSrcset?: string;
  urlWebpSrcset?: string;
  urlBlurDataUrl?: string;
  alt?: string;
  caption?: string;
  fullWidth?: boolean;
}

export function ImageBlock({ props }: { props: ImageProps }) {
  if (!props.url) return null;
  return (
    <figure className={props.fullWidth ? 'w-full' : 'max-w-2xl mx-auto'}>
      <ResponsiveImage
        src={props.url}
        srcset={props.urlSrcset}
        webpSrcset={props.urlWebpSrcset}
        blurDataUrl={props.urlBlurDataUrl}
        alt={props.alt ?? ''}
        className="w-full rounded-xl object-cover"
      />
      {props.caption && (
        <figcaption className="text-center text-xs text-zinc-400 mt-2">{props.caption}</figcaption>
      )}
    </figure>
  );
}
